import { render } from "./TrailerArial.vue?vue&type=template&id=78148dfa&scoped=true"
import script from "./TrailerArial.vue?vue&type=script&lang=js"
export * from "./TrailerArial.vue?vue&type=script&lang=js"

import "./TrailerArial.vue?vue&type=style&index=0&id=78148dfa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78148dfa"]])

export default __exports__